module.exports = __webpack_public_path__ + "img/D13.b63ae66c.png";